import LoanDetailsContainer from 'containers/Microloans/LoanDetails';

export default {
  exact: true,
  name: 'Loan-details',
  protected: true,
  path: '/loan-details',
  component: LoanDetailsContainer,
};
